import { useMemo } from 'react';
import { Plan } from '@/services/frandroid-api';
import { computeHighlights, PlanWithHighlight, HighlightConfig } from '@/utils/highlights';

export function useHighlights(
  plans: Plan[],
  config: HighlightConfig
): PlanWithHighlight[] {
  // Callers pass a literal object, so `config` changes reference on every
  // render: destructure so the dependencies are exactly the two fields read,
  // which is also what the memo was already using as keys.
  const { highlightIds, planType } = config;

  return useMemo(
    () => computeHighlights(plans, { highlightIds, planType }),
    [plans, highlightIds, planType]
  );
}
